import { QueryClient } from "@tanstack/react-query";

import { invalidateQuoteRequestLineDetails } from "#modules/optimizations/infra/invalidateQuoteRequestLineDetails";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const invalidateOptimizedMaterialCosts = (
  queryClient: QueryClient,
  quoteRequestId: string,
  lineIds: string[],
) => {
  void queryClient.invalidateQueries({
    queryKey: queryKeys.optimizations.enabledByQuoteRequest(quoteRequestId),
  });
  invalidateQuoteRequestLineDetails(queryClient, lineIds);
};
